import { Link, useLocation } from 'react-router-dom';
import type { CSSProperties } from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TerrainIcon from '@mui/icons-material/Terrain';
import PersonIcon from '@mui/icons-material/Person';

const styles = {
  container: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 56,
    backgroundColor: 'var(--color-bg-primary)',
    borderTop: '1px solid var(--color-border)',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    zIndex: 100,
    paddingBottom: 'env(safe-area-inset-bottom)',
  } satisfies CSSProperties,
  tab: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    color: 'var(--color-text-secondary)',
    fontSize: 12,
    gap: 2,
    flex: 1,
    height: '100%',
    transition: 'color 0.2s ease',
  } satisfies CSSProperties,
  tabActive: {
    color: 'var(--color-primary)',
  } satisfies CSSProperties,
  icon: {
    fontSize: 24,
  } satisfies CSSProperties,
  label: {
    fontSize: 11,
    fontWeight: 500,
  } satisfies CSSProperties,
};

const tabs = [
  { path: '/gyms', label: 'Gyms', Icon: LocationOnIcon, id: 'nav-tab-gyms' },
  { path: '/climb', label: 'Climb', Icon: TerrainIcon, id: 'nav-tab-climb' },
  { path: '/profile', label: 'Profile', Icon: PersonIcon, id: 'nav-tab-profile' },
];

export function BottomTabBar() {
  const location = useLocation();

  return (
    <nav style={styles.container} aria-label="Main navigation">
      {tabs.map(({ path, label, Icon, id }) => {
        const isActive = location.pathname.startsWith(path);
        return (
          <Link
            key={path}
            id={id}
            to={path}
            style={{
              ...styles.tab,
              ...(isActive ? styles.tabActive : {}),
            }}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon
              style={{
                ...styles.icon,
                color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
              }}
            />
            <span
              style={{
                ...styles.label,
                color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
              }}
            >
              {label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}
